import React from 'react';
import classNames from 'classnames';
import { PureComponent } from '../../../dispatcher/modules';
import { FIELD_PROPS } from './Types';

/**
 * This class/component has the role of wrapping each field type(Input, NumericTextbox, Textarea, etc...)
 * for the purposes of layout, and its structure
 * @author Stevan Stojanovic
 */
class Field extends PureComponent<FIELD_PROPS, {}> {
  render() {
    const {
      children,
      fieldClassName,
      fieldMandatory,
      fieldWithAdditionalEl
    } = this.props;

    const cls = classNames(
      `k-form-field ${fieldClassName}`,
      {
        'tp-with-additional-element': fieldWithAdditionalEl,
        'k-mandatory': fieldMandatory
      }
    );

    return (
      <div className={cls}>
        {children}
      </div>
    );
  }
}

export default Field;
